import { Prompt } from '~/shared/components/Prompt';
import { getPatientOverviewOptions, respondToInitialAssessmentOptions } from '@generated';
import { useMutation } from '~/util/http/useMutation';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Button } from '~/shared/components/buttons/Button';
import { SquareArrowRight } from 'lucide-react';
import { getVisitRoutePath, useVisitPageParams } from '~/pages/visits/utils';
import { useGetFullVisitOptions } from '../../queries';

export function InitialAssessmentPrompt() {
	const navigate = useNavigate();
	const { visitId, stayId } = useVisitPageParams();
	const { data: visit, refetch } = useSuspenseQuery(useGetFullVisitOptions(visitId));
	const { refetch: refetchPatientOverview } = useQuery(getPatientOverviewOptions(stayId));
	const respondToPrompt = useMutation<string>(respondToInitialAssessmentOptions);
	if (!visit.promptingToAdmit) {
		return null;
	}

	//navigate to the next bucket in the workflow
	const onAction = () => {
		respondToPrompt.mutate(
			{
				stayId,
				admitPatient: true,
				visitId
			},
			{
				onSuccess: (result: string) => {
					refetch();
					refetchPatientOverview();
					const nextBucket = visit.visitBuckets.find(x => x.id === result);
					if (!nextBucket) {
						throw new Error('Next visit bucket not found after admitting patient');
					}
					navigate(getVisitRoutePath(stayId, visitId, result, nextBucket.firstBucketItemId!));
				}
			}
		);
	};

	return (
		<Prompt
			intent="custom"
			title="Admit Patient"
			text="Would you like to admit this patient and continue to the next step?"
			closeOnAction={false}
		>
			<Button intent="destructive" onClick={() => {}} label="NTFC" />
			<Button autoFocus onClick={onAction} label="Admit & Continue" Icon={SquareArrowRight} isPending={respondToPrompt.isPending} />
		</Prompt>
	);
}
